import { IRootState } from '../../reducer';

export const selectIsNoFreeSeatsModalOpen = (rootState: IRootState): boolean => {
  return rootState.modals.noFreeSeatsModal.isOpen;
};
